import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "flex flex-col space-y-2 text-center shadow rounded" }
const _hoisted_2 = { class: "text-3xl" }
const _hoisted_3 = { class: "flex space-x-1 justify-center py-8" }
const _hoisted_4 = { class: "text-4xl" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", null, "$ /month", -1)
const _hoisted_6 = { class: "px-8 pb-8 flex flex-col space-y-4" }
const _hoisted_7 = { class: "flex space-x-4" }
const _hoisted_8 = /*#__PURE__*/_createTextVNode()
const _hoisted_9 = /*#__PURE__*/_createElementVNode("p", null, "click to translate", -1)
const _hoisted_10 = { class: "flex space-x-4" }
const _hoisted_11 = /*#__PURE__*/_createTextVNode()
const _hoisted_12 = /*#__PURE__*/_createElementVNode("p", null, "click to search image", -1)
const _hoisted_13 = { class: "flex space-x-4" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("div", null, "browser plugin", -1)
const _hoisted_15 = { class: "flex" }
const _hoisted_16 = /*#__PURE__*/_createTextVNode(" images per search")
const _hoisted_17 = { class: "flex" }
const _hoisted_18 = /*#__PURE__*/_createTextVNode(" translations per day ")
const _hoisted_19 = /*#__PURE__*/_createElementVNode("p", null, "create audio", -1)
const _hoisted_20 = /*#__PURE__*/_createElementVNode("p", null, "single click mode", -1)

import { PricingTier } from "@/PricingTier";
import YesOrNoIcon from "@/components/YesOrNoIcon.vue";
import { computed } from "vue";

interface Props {
  tier: PricingTier;
}

export default /*#__PURE__*/_defineComponent({
  props: {
    tier: null
  },
  setup(__props: any) {

const props = __props as {
  tier: PricingTier;
}


const isFreeTier = computed(()=>props.tier.name == "free")
const proFeatureTextColor= computed(()=>{
	if(isFreeTier.value) return "gray-400";
	return "black"
})

const nameColor=computed(()=>{
	if(isFreeTier.value) return "warning";
	return "success"

})
const numberColor=computed(()=>{
	if(isFreeTier.value) return "palette5";
	return "success"

})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: _normalizeClass(`bg-${_unref(nameColor)} rounded-t text-white px-4 py-4`)
    }, [
      _createElementVNode("div", _hoisted_2, _toDisplayString(__props.tier.name), 1)
    ], 2),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, _toDisplayString(__props.tier.price), 1),
      _hoisted_5
    ]),
    _createElementVNode("div", _hoisted_6, [
      _createElementVNode("div", _hoisted_7, [
        _createVNode(YesOrNoIcon, {
          value: __props.tier.canTranslate
        }, null, 8, ["value"]),
        _hoisted_8,
        _hoisted_9
      ]),
      _createElementVNode("div", _hoisted_10, [
        _createVNode(YesOrNoIcon, { value: true }),
        _hoisted_11,
        _hoisted_12
      ]),
      _createElementVNode("div", _hoisted_13, [
        _createVNode(YesOrNoIcon, {
          value: __props.tier.browserPlugin
        }, null, 8, ["value"]),
        _hoisted_14
      ]),
      _createElementVNode("div", _hoisted_15, [
        _createElementVNode("strong", {
          class: _normalizeClass(`pr-5 pl-2 text-${_unref(numberColor)}`)
        }, _toDisplayString(__props.tier.imageSearchResults), 3),
        _hoisted_16
      ]),
      _createElementVNode("div", _hoisted_17, [
        _createElementVNode("strong", {
          class: _normalizeClass(`pr-4 text-${_unref(numberColor)}`)
        }, _toDisplayString(__props.tier.translationDailyLimit), 3),
        _hoisted_18
      ]),
      _createElementVNode("div", {
        class: _normalizeClass(`flex space-x-4 text-${_unref(proFeatureTextColor)}`)
      }, [
        _createVNode(YesOrNoIcon, {
          value: __props.tier.canAddAudio
        }, null, 8, ["value"]),
        _hoisted_19
      ], 2),
      _createElementVNode("div", {
        class: _normalizeClass(`flex space-x-4 text-${_unref(proFeatureTextColor)}`)
      }, [
        _createVNode(YesOrNoIcon, {
          value: __props.tier.singleClickMode
        }, null, 8, ["value"]),
        _hoisted_20
      ], 2)
    ])
  ]))
}
}

})